import * as React from "react";

import {Button as PopUpButton, Dropdown, Icon, Popup, Button} from 'semantic-ui-react';
import {VIEWNAME} from "../../../../utils/GeneralUtils";
import {LanguageDto} from "../../../../services/Client";
import {lang2flag} from "../../../MultiLineColumn";
import GlobalSearchInput from "../basic/GlobalSearchInput";

interface IAdvancedModeHeader {
    [key: string]: any;
}
class AdvancedModeHeader extends React.Component<IAdvancedModeHeader> {
    constructor(props: IAdvancedModeHeader) {
        super(props);
    }

    render() {
        const {
            inEditMode,
            viewName,
            hasHistoryButton,
            hasNewButton = false,
            hasCopyButton = false,
            hasDeleteButton = false,
            hasMultipleDeleteButton = false,
            hasEditButton = false,
            hasReloadButton = false,
            hasExportButton = false,
            hasExcelExportButtonV2 = false,
            hasSpecificOptionButton = false,
            hasCompareButton = false,
            hasTransferAssignmentsButton = false,
            hasWorkflowStatusMultiUpdateButton = false,
            hasCheckPCCDSyncronisationButton = false,
            hasUpdateDraftAssignmentsButton = false,
            hasSelectLanguageButton = false,
            isGlobalSearch = false,
            disabledNewButton = false,
            disabledCopyButton = false,
            disabledDeleteButton = false,
            disabledMultipleDeleteButton = false,
            disabledEditButton = false,
            disabledReloadButton = false,
            disabledExportButton = false,
            disabledExcelExportButtonV2 = false,
            disabledSpecificOptionButton = false,
            disabledCompareButton = false,
            disableTransferAssignmentsButton = true,
            disableWorkflowStatusMultiUpdateButton = true,
            disableCheckPCCDSyncronisationButton = true,
            disableUpdateDraftAssignmentsButton = true,
            disabledSelectLanguageButton = false,
            labelHistoryButton,
            labelNewButton = "",
            labelCopyButton = "",
            labelDeleteButton = "",
            labelMultipleDeleteButton = "",
            labelEditButton = "",
            labelReloadButton = "",
            labelExportButton = "",
            labelExcelExportButtonV2 = "",
            labelSpecificOptionButton = "",
            labelCompareButton = "",
            labelTransferAssignmentsButton = "",
            labelWorkflowStatusMultiUpdateButton = "",
            labelCheckPCCDSyncronisationButton = "",
            labelUpdateDraftAssignmentsButton = "",
            labelSelectLanguageButton = "",
            labelTextSearch = "",
            labelValidationFilter = "",
            onClickHistoryButton,
            disableHistoryButton,
            onClickNewButton,
            onClickCopyButton,
            onClickDeleteButton,
            onClickMultipleDeleteButton,
            onClickEditButton,
            onClickReloadButton,
            onClickExportButton,
            onClickExcelExportButtonV2,
            onClickSpecificOptionButton,
            onClickCompareButton,
            onClickTransferAssignmentsButton,
            onClickWorkflowStatusMultiUpdateButton,
            onClickCheckPCCDSyncronisationButton,
            onClickUpdateDraftAssignmentsButton,
            onClickSelectLanguageButton,
            deleteButtonExchangeLabel,
            onClickInitPslButton,
            labelPslButton,
            hasInitPslButton,
            iconNewButton,
            selectedLanguages,
            languageList,
            labelFlagMultiUpdateButton,
            onClickFlagMultiUpdate,
            btnActiveDeactiveIcon,
            disabledActiveInactiveButton,
            labelActiveInactiveButton,
            onClickActiveDeactiveButton,
            onGlobalSearchChange,
            isGlobalSearchBtn,
            goToNextMatch,
            goToPrevMatch,
            globalSearchText
        } = this.props;

        const btnNew = !hasNewButton || disabledNewButton
            ? undefined
            : (
                <Popup
                    trigger={
                        <PopUpButton
                            icon={iconNewButton}
                            onClick={onClickNewButton}
                            disabled={!hasNewButton || disabledNewButton}
                            className='table-header-button'
                        />
                    }
                    content={labelNewButton}
                    inverted={true}
                    position='bottom left'
                />
            );

        const btnCopy = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="copy"
                        onClick={onClickCopyButton}
                        disabled={!hasCopyButton || disabledCopyButton}
                        className='table-header-button'
                    />
                }
                content={labelCopyButton}
                inverted={true}
                position='bottom left'
            />
        );

        const btnHistory = (
            <Popup
                trigger={
                    < PopUpButton
                        icon="history"
                        onClick={onClickHistoryButton}
                        disabled={!hasHistoryButton || disableHistoryButton}
                        className='table-header-button'
                    />
                }
                content={labelHistoryButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnDelete = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="delete"
                        onClick={onClickDeleteButton}
                        className='table-header-button'
                        disabled={!hasDeleteButton || disabledDeleteButton}
                    />
                }
                content={deleteButtonExchangeLabel ? deleteButtonExchangeLabel : labelDeleteButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnActiveDeactive = (
            <Popup
                trigger={
                    <PopUpButton
                        icon={btnActiveDeactiveIcon}
                        onClick={onClickActiveDeactiveButton}
                        className='table-header-button'
                        disabled={disabledActiveInactiveButton}
                    />
                }
                content={labelActiveInactiveButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnMultipleDelete = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="delete"
                        onClick={onClickMultipleDeleteButton}
                        className='table-header-button'
                        disabled={!hasMultipleDeleteButton || disabledMultipleDeleteButton}
                    />
                }
                content={labelMultipleDeleteButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnEdit = !hasEditButton || disabledEditButton
            ? undefined
            : (
                <Popup
                    trigger={
                        <PopUpButton
                            icon="edit"
                            onClick={onClickEditButton}
                            disabled={disabledEditButton}
                            className={`table-header-button  ${inEditMode ? 'active-dropdown-button' : ''}`}
                        />
                    }
                    content={labelEditButton}
                    inverted={true}
                    position='bottom left'

                />
            );

        const btnReload = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="refresh"
                        onClick={onClickReloadButton}
                        disabled={!hasReloadButton || disabledReloadButton}
                        className='table-header-button'
                    />
                }
                content={labelReloadButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnSpecificOption = !hasSpecificOptionButton || disabledSpecificOptionButton
            ? undefined
            : (
                <Popup
                    trigger={
                        <PopUpButton
                            icon="file"
                            disabled={disabledSpecificOptionButton}
                            onClick={onClickSpecificOptionButton}
                            className='table-header-button'
                        />
                    }
                    content={labelSpecificOptionButton}
                    inverted={true}
                    position='bottom center'
                />
            );

        const btnExport = !hasExportButton
            ? undefined
            : (
                <Popup
                    trigger={
                        <PopUpButton
                            loading={disabledExportButton}
                            disabled={disabledExportButton}
                            icon='file alternate outline'
                            onClick={onClickExportButton}
                            className='table-header-button'
                        />
                    }
                    content={labelExportButton}
                    inverted={true}
                    position='bottom center'
                />
            );

        const btnExcelExportV2 = !hasExcelExportButtonV2
            ? undefined
            : (
                <Popup
                    trigger={
                        <PopUpButton
                            loading={disabledExcelExportButtonV2}
                            disabled={disabledExcelExportButtonV2}
                            icon="wordpress forms"
                            onClick={onClickExcelExportButtonV2}
                            className='table-header-button'
                        />
                    }
                    content={labelExcelExportButtonV2}
                    inverted={true}
                    position='bottom center'
                />
            );

        const btnCompare = !hasCompareButton || disabledCompareButton
            ? undefined
            : (
                <Popup
                    trigger={
                        <PopUpButton
                            icon="exchange"
                            onClick={onClickCompareButton}
                            className='table-header-button'
                        />
                    }
                    content={labelCompareButton}
                    inverted={true}
                    position='bottom center'
                />
            );

        const btnTransferAsgn = (
            <Popup
                trigger={
                    <span style={{display: 'inline-block'}}>
                        <PopUpButton
                            icon="exchange"
                            onClick={onClickTransferAssignmentsButton}
                            disabled={!hasTransferAssignmentsButton || disableTransferAssignmentsButton}
                            className='table-header-button'
                            tabIndex={-1}
                        />
                    </span>}
                content={
                    (!hasTransferAssignmentsButton || disableTransferAssignmentsButton)
                        ? labelValidationFilter
                        : labelTransferAssignmentsButton
                }
                inverted={true}
                position='bottom center'
            />
        );
        const btnWorkflowStatusMultiUpdate = (
            <Popup
                trigger={
                    <PopUpButton
                        onClick={onClickWorkflowStatusMultiUpdateButton}
                        disabled={!hasWorkflowStatusMultiUpdateButton || disableWorkflowStatusMultiUpdateButton}
                        className='table-header-button'
                    >
                        <span>
                            <Icon name="fast backward" style={{margin: 0}} />
                            <Icon name="step forward" style={{margin: 0}} />
                        </span>
                    </PopUpButton>
                }
                content={labelWorkflowStatusMultiUpdateButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnCheckPCCDSyncronisation = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="random"
                        disabled={!hasCheckPCCDSyncronisationButton || disableCheckPCCDSyncronisationButton}
                        onClick={onClickCheckPCCDSyncronisationButton}
                        className='table-header-button'
                    />
                }
                content={labelCheckPCCDSyncronisationButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnUpdateDraftAssignments = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="angle double up"
                        onClick={onClickUpdateDraftAssignmentsButton}
                        disabled={!hasUpdateDraftAssignmentsButton || disableUpdateDraftAssignmentsButton}
                        className='table-header-button'
                    />
                }
                content={labelUpdateDraftAssignmentsButton}
                inverted={true}
                position='bottom center'
            />
        );

        const btnInitPsl = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="car"
                        onClick={onClickInitPslButton}
                        className='table-header-button'
                        disabled={!hasInitPslButton}
                    />
                }
                content={labelPslButton}
                inverted={true}
                position='bottom left'
            />
        );

        const btnSelectLanguage = !hasSelectLanguageButton || disabledSelectLanguageButton
            ? undefined
            : (
                <Dropdown
                    style={{width: "210px", margin: "auto 5px", height: '40px', marginTop: '5px', marginRight: '10px', padding: '13px'}}
                    fluid={true}
                    text={labelSelectLanguageButton}
                    labeled={true}
                    button={true}
                    className='icon table-header-button'
                    loading={disabledSelectLanguageButton}
                    disabled={disabledSelectLanguageButton}
                    scrolling={true}
                >
                    <Dropdown.Menu>
                        {languageList && languageList.map((item: LanguageDto, index: number) => {
                            let checked: boolean = false;
                            selectedLanguages.forEach((val: LanguageDto) => {
                                if (val.vmce === item.vmce) {
                                    checked = true;
                                }
                            });
                            return (
                                item && <Dropdown.Item
                                    key={index}
                                    text={item.nameDe}
                                    flag={lang2flag(item.vmce)}
                                    icon={checked ? "check" : ""}
                                    disabled={(selectedLanguages.length >= 2 && !checked) ? true : false}
                                    onClick={() => onClickSelectLanguageButton(index)}
                                />
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown >
            );
        const btnMultiFlagUpdate = (
            <Popup
                trigger={
                    <PopUpButton
                        icon="flag"
                        onClick={onClickFlagMultiUpdate}
                        disabled={!hasWorkflowStatusMultiUpdateButton || disableWorkflowStatusMultiUpdateButton}
                        className='table-header-button'
                    />
                }
                content={labelFlagMultiUpdateButton}
                inverted={true}
                position='bottom center'
            />
        );
        return (
            <div style={{display: 'flex'}}>
                {btnSpecificOption}
                {btnEdit}
                {(viewName === VIEWNAME.DERIVATEVIEW || viewName === VIEWNAME.BASICOPTIONVIEW || viewName === VIEWNAME.KUMAVIEW) && btnNew}
                {viewName === VIEWNAME.BASICOPTIONVIEW && btnInitPsl}
                {btnCompare}
                {(viewName === VIEWNAME.DERIVATEVIEW || viewName === VIEWNAME.OPTIONVIEW) && btnCopy}
                {viewName !== VIEWNAME.OPTIONVIEW && btnDelete}
                {viewName === VIEWNAME.KUMAVIEW && btnActiveDeactive}
                {viewName === VIEWNAME.OPTIONVIEW && btnMultipleDelete}
                {(btnExport || btnExcelExportV2) &&
                    <>
                        <div className='buttons-vertical-splitter' />
                        {btnExport}
                        {btnExcelExportV2}
                    </>
                }
                {((btnTransferAsgn || btnUpdateDraftAssignments || btnWorkflowStatusMultiUpdate || btnMultiFlagUpdate) && viewName === VIEWNAME.OPTIONVIEW) &&
                    <>
                        <div className='buttons-vertical-splitter' />
                        {btnTransferAsgn}
                        {btnUpdateDraftAssignments}
                        {btnWorkflowStatusMultiUpdate}
                        {btnMultiFlagUpdate}
                    </>
                }
                {
                    (btnCheckPCCDSyncronisation || btnHistory) &&
                    <>
                        <div className='buttons-vertical-splitter' />
                        {btnCheckPCCDSyncronisation}
                        {btnHistory}
                    </>
                }
                {
                    btnSelectLanguage &&
                    <>
                        <div className='buttons-vertical-splitter' />
                        {btnSelectLanguage}
                    </>
                }
                {
                    btnReload &&
                    <>
                        <div className='buttons-vertical-splitter' />
                        {btnReload}
                    </>
                }
                {
                    isGlobalSearch &&
                    <>
                        <div className='buttons-vertical-splitter' />
                        <GlobalSearchInput onGlobalSearchChange={onGlobalSearchChange} placeholder={labelTextSearch} value={globalSearchText} />
                        {isGlobalSearchBtn && <div className="next-previous-btn">
                            <Button circular={true} icon="angle down" onClick={goToNextMatch} />
                            <Button circular={true} icon="angle up" onClick={goToPrevMatch} />
                        </div>}

                    </>
                }
            </div >
        );
    }
}

export default AdvancedModeHeader;



// WEBPACK FOOTER //
// ./src/components/Table/components/headerComponents/AdvancedModeHeader.tsx